import { render, staticRenderFns } from "./Preset.vue?vue&type=template&id=10b10a40&scoped=true"
import script from "./Preset.vue?vue&type=script&lang=js"
export * from "./Preset.vue?vue&type=script&lang=js"
import style0 from "./Preset.vue?vue&type=style&index=0&id=10b10a40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b10a40",
  null
  
)

export default component.exports